import { select, put } from 'redux-saga/effects'
import * as types from './types'
import { getFactoidsFromSelections} from '../../lib/helpers'

function* onClassDeleteHandler(action: any) {
  const classId = action.payload.id
  const factoidSelections = yield select(
    (state: any) => state.views.new.selections.factoids
  )
  const factoidData = yield select((state: any) => state.data.factoids)


  /**
   * An asset class was deselected,
   * makes sense to remove all selected factoids 
   * that are associated with it
   */
  const filteredFactoidSelections = factoidSelections.filter(
    (factoidId: number) => {
      const activefactoid = factoidData.find(
        (factoid: any) => factoid.id === factoidId
      )
      if (!activefactoid.classes.includes(classId)) {
        return factoidId
      }
      return false
    }
  )

  yield put({
    type: types.FACTOID_SELECTIONS_SORT_SUCCESS,
    payload: filteredFactoidSelections
  })
}

function* generateBusinessLineSelections(action: any) {
  const businessLineSelections = yield select(
    (state: any) => state.views.new.selections.businessLines
  )

  if (action.type === types.USER_SELECT_FACTOID) {

    yield put({
      type: types.USER_ADD_BUSINESS_LINE,
      payload: { id: action.payload.businessLineId }
    })
  } else {
    const factoidData = yield select((state: any) => state.data.factoids)
    const factoidSelections = yield select(
      (state: any) => state.views.new.selections.factoids
    )

    // Get all existing factoids that are related to BL (after factoid has been removed)
    const sameSelectedBusinessLineFactoids = factoidData.filter((factoid: any) =>
      factoidSelections.includes(factoid.id) && factoid.business_line[0] === action.payload.businessLineId
  )

    // If there are no related factoids to BL, makes BL irrelevant, deselect it
    if (sameSelectedBusinessLineFactoids.length === 0) {
      yield put({
        type: types.GENERATE_BUSINESS_LINE_SELECTIONS,
        payload: businessLineSelections.filter(
          (serviceLine: number) => serviceLine !== action.payload.businessLineId
        )
      })
    }
  }
}

function* onBusinessLineDeleteHandler(action: any) {
  const businessLineId: number = action.payload.id
  const factoidSelections = yield select(
    (state: any) => state.views.new.selections.factoids
  )
  const factoidData = yield select((state: any) => state.data.factoids)

  /**
   * BL deselected means factoids associated with it should also be removed,
   * so lets grab those factoids
   */
  const activeFactoids = getFactoidsFromSelections(factoidSelections, factoidData)

  yield put({
    type: types.FACTOID_SELECTIONS_SORT_SUCCESS,
    payload: activeFactoids
      .filter((factoid: any) => factoid.business_line[0] !== businessLineId)
      .map((factoid: any) => factoid.id)
  })
}

function* handleBusinesslineRecommendationAdd(action: any) {
  const businessLineId: number = action.payload.id
  const assetClassSelections = yield select(
    (state: any) => state.views.new.selections.classes
  )
  const factoidData = yield select((state: any) => state.data.factoids)
  const factoidSelections = yield select(
    (state: any) => state.views.new.selections.factoids
  )

  // Grab all the factoids that are related to the BL and also any of the asset classes selected
  const relatedFactoids = factoidData
    .filter(
      (factoid: any) =>
        factoid.business_line.includes(businessLineId) &&
        assetClassSelections.some((classId: number) =>
          factoid.classes.includes(classId)
        )
    )
    .map((factoid: any) => factoid.id)

  // Load those factoids as selections
  yield put({
    type: types.FACTOID_SELECTIONS_SORT_SUCCESS,
    payload: [...factoidSelections, ...relatedFactoids]
  })
  // Add the business line as a selection
  yield put({
    type: types.USER_ADD_BUSINESS_LINE,
    payload: { id: businessLineId }
  })
}

export {
  onClassDeleteHandler,
  generateBusinessLineSelections,
  onBusinessLineDeleteHandler,
  handleBusinesslineRecommendationAdd
}



// WEBPACK FOOTER //
// ./src/views/duck/operations.ts